import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import StreamingRegistrationRedirectionBlockData from '../../../Models/Content/StreamingRegistrationRedirectionBlockData';
import CheckStreamingRegistrationStatusAndRedirectMain from './CheckStreamingRegistrationStatusAndRedirectMain';

export default class StreamingRegistrationRedirectionBlock extends EpiComponent<StreamingRegistrationRedirectionBlockData> {
  public render(): ReactNode | null {
    return <CheckStreamingRegistrationStatusAndRedirectMain contentData={this.props.data} context={this.getContext()} />;
  }
}
